import type { Event, RSVP } from '@/types';

export interface RsvpQuestionAnswer {
  question: string;
  answer: string;
}

/** Answers to the event's Additional Questions, in questionnaire order. RSVPs store them keyed by question text. */
export function getRsvpQuestionAnswers(rsvp: RSVP, event: Event): RsvpQuestionAnswer[] {
  const answers: RsvpQuestionAnswer[] = [];
  for (const item of event.questionnaire ?? []) {
    const raw = rsvp.responses?.[item.question];
    const values: unknown[] = Array.isArray(raw) ? raw : [raw];
    const answer = values
      .filter((value) => typeof value === 'string' || typeof value === 'number')
      .map((value) => String(value).replace(/\s+/g, ' ').trim())
      .filter(Boolean)
      .join(', ');
    if (answer) {
      answers.push({ question: item.question, answer });
    }
  }
  return answers;
}

/** Single-line form for exports and table search, e.g. "Parking?: Yes | Interests: Golf, Music". */
export function formatRsvpQuestionAnswers(rsvp: RSVP, event: Event): string {
  return getRsvpQuestionAnswers(rsvp, event)
    .map(({ question, answer }) => `${question}: ${answer}`)
    .join(' | ');
}
